// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2L7Ai","search":"Settings_search__1cgmU","filter":"Settings_filter__3dPAQ"};